/**************************************************
 * Nombre:       Producto_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Rating, Typography} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Producto_Detalle = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: '#00000020',
                borderRadius: 4,
                p: 3
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: !masSM ? 24 : 32, fontWeight: 600, lineHeight: 1.1}}>Vick fort 9 alivio contra los sintomas
                    de la
                    gripa</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Rating sx={{mt: -0.2, mb: 0, pr: 1}}/> <Typography sx={{color: '#00000050', fontSize: 16}}>
                <span></span> 60.000
            </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: !masSM ? 16 :20, fontWeight: 400}}>
                    Caja x 36 capsula blanda
                    Vick fort 9 alivio contra los sintomas de la gripa
                    Referencia: KIT154834
                    Incluye 0% de impuestos
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Typography sx={{color: '#000000', fontSize: !masSM ? 16 : 18, fontWeight: 600}}>
                    <span style={{color: '#808488', marginRight: 6}}>1.800 Und</span> $ 22.320 X12 Und
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Button fullWidth>Comprar Ahora</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Button fullWidth
                        sx={{backgroundColor: '#E6E6FF', color: '#5356FF'}}
                >Agregar al Carrito</Button>
            </Grid>

        </Grid>
    )

}
export default Producto_Detalle